import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IPartialUnit } from 'projects/lib-ui/src/shared/interfaces/unit';
import { IResponse } from 'projects/lib-ui/src/shared/interfaces/response';

@Injectable()
export class UnitService {
  private readonly URI_API = environment.URLAPI + 'Branch';

  constructor(private readonly httpClient: HttpClient) {
  }

  getUnits(searchText: string): Observable<IResponse<IPartialUnit[]>> {
    return this.httpClient.get<IResponse<IPartialUnit[]>>(
      `${this.URI_API}/with-devices?SearchString=${searchText}`
    ).pipe(
      map((response) => ({
        ...response,
        data: Array.isArray(response.data)
          ? response.data.map((unit) => ({
            ...unit,
            availableDevices: Array.isArray(unit.availableDevices)
              ? unit.availableDevices.map((device) => ({ ...device }))
              : []
          }))
          : []
      }))
    );
  }
}
